import { RedirectToLoginGuard } from "../shared/services/security/redirectToLoginGuard";
import { AuthorizeGuard } from "../shared/services/security/authorizeGuard";
//components
import { LogShellComponent } from './log-shell.component';
import {LogListComponent} from './log/list/list.component';
import {LogEditComponent} from './log/edit/edit.component';

export const logs = [
  {
    path: "list",
    component: LogListComponent,
    canActivate: [RedirectToLoginGuard],
    data: {
      mustHave: {
        permissions: []
      }
    }
  },
  {
    path: "edit/:id",
    component: LogEditComponent,
    canActivate: [RedirectToLoginGuard],
    data: {
      mustHave: {
        permissions: []
      }
    }
  }
]
